import Tool, { type IToolActionInput } from './Tool';
import ToolDelete from './ToolDelete';
import ToolCopy from './ToolCopy';
import DisableWhileUploadingBehavior from './DisableWhileUploadingBehavior';
import Shortcut from '../utils/Shortcut';

@DisableWhileUploadingBehavior
class ToolCut extends Tool {
  static toolName = 'Cut objects';
  static shortcut = new Shortcut('Cmd+X');

  static action({ controller, selection }: IToolActionInput) {
    ToolCopy.action({ controller, selection });
    ToolDelete.action({ controller, selection });
  }
}

export default ToolCut;
